import { render } from "./receiptCollect.vue?vue&type=template&id=329b8266&scoped=true"
import script from "./receiptCollect.vue?vue&type=script&lang=js"
export * from "./receiptCollect.vue?vue&type=script&lang=js"

import "./receiptCollect.vue?vue&type=style&index=0&id=329b8266&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329b8266"]])

export default __exports__